import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

import { matchUiAction } from "../detect";
import { Matcher } from "../types";
import { applyAndSettle } from "./settle";

export const setVariation: Matcher = {
  // Switch the preview to the requested variation. The next turn loads with
  // fresh page HTML and `context.variationId` reflecting the new selection. Use
  // `setVariationId` directly (not the `switchVariationId` thunk) because the AI
  // flow doesn't need draft-discard prompting — the UI is locked during AI
  // turns. Switching re-applies mods (like update_mods), so `applyAndSettle` waits
  // for the reload/live-apply — but only when the target actually changes the
  // preview state.
  match: (part) => {
    const results = matchUiAction(part, "setVariation");
    if (!results) return null;
    return async (api) => {
      const target = results.variationId;
      if (typeof target !== "string" || !target) {
        // Don't report a switch that didn't happen — the id was missing/invalid.
        return {
          kind: "user",
          message:
            "[system] No variation switch performed: the requested variation id was missing or invalid.",
        };
      }
      const current = experienceBuilderSlice.selectors.getVariationId(
        api.getState()
      );
      if (target !== current) {
        await applyAndSettle(api, () =>
          api.dispatch(experienceBuilderSlice.actions.setVariationId(target))
        );
      }
      return {
        kind: "user",
        message: `[system] Preview switched to variation ${target}. Fresh page HTML and context.mods reflect this variation.`,
      };
    };
  },
};
